import { useContext, useEffect, useState } from "react";
import { MapContext } from "../context/MapContext";
import { Button } from "react-bootstrap";
import IndividualDrawColorSettingModal from "./modal/IndividualDrawColorSettingModal";

const IndividualDrawColorSettingBtn = () => {
  // 図形コントロールをコンテキストから取得
  const { drawCtl, drawColorRef } = useContext(MapContext);
  const drawColor = drawColorRef.current;
  // State管理
  const [selectedFigureId, setSelectedFigureId] = useState(null);
  // ダイアログ管理
  const [drawColorSettingModalShow, setDrawColorSettingModalShow] =
    useState(false);

  // Terradrawのイベント設定
  useEffect(() => {
    if (!(drawCtl && drawCtl?.options?.adapterOptions?.prefixId === "td")) {
      return;
    }

    const drawInstance = drawCtl.getTerraDrawInstance();
    !drawInstance.enabled && drawInstance.start();
    // イベントの設定
    drawInstance.on("select", (id) => {
      setSelectedFigureId(id);
    });
    drawInstance.on("deselect", () => {
      setSelectedFigureId(null);
    });
    // 色の設定
    // ラインの色設定
    drawInstance.setModeStyles("linestring", {
      lineStringColor: (feature) => {
        const color = drawColor[feature.id] ?? drawColor.default.lineString;
        return color.lineStringColor;
      },
      lineStringWidth: (feature) => {
        const color = drawColor[feature.id] ?? drawColor.default.lineString;
        return color.lineStringWidth;
      },
    });
    // ポリゴンの色設定
    drawInstance.setModeStyles("polygon", {
      fillColor: (feature) => {
        const color = drawColor[feature.id] ?? drawColor.default.polygon;
        return color.fillColor;
      },
      fillOpacity: (feature) => {
        const color = drawColor[feature.id] ?? drawColor.default.polygon;
        return color.fillOpacity;
      },
      outlineColor: (feature) => {
        const color = drawColor[feature.id] ?? drawColor.default.polygon;
        return color.outlineColor;
      },
      outlineWidth: (feature) => {
        const color = drawColor[feature.id] ?? drawColor.default.polygon;
        return color.outlineWidth;
      },
    });
  }, [drawColor, drawCtl]);

  // ボタン制御
  useEffect(() => {
    const btn = document.querySelector("#terradrawColorSetting");
    btn && (btn.disabled = !selectedFigureId);
  }, [selectedFigureId]);

  return (
    <>
      <Button
        variant="primary"
        id="individualDrawColorSettingBtn"
        onClick={() => {
          setDrawColorSettingModalShow(true);
        }}
      >
        図形色設定
      </Button>
      <IndividualDrawColorSettingModal
        show={drawColorSettingModalShow}
        handleClose={() => {
          setDrawColorSettingModalShow(false);
        }}
        id={selectedFigureId}
      />
    </>
  );
};

export default IndividualDrawColorSettingBtn;
